module.exports = __webpack_public_path__ + "img/outlook.0f0a3c58.png";